export default "__VITE_ASSET__6dcdebb4__"